<template>
    <HomeLayout>
        <router-view></router-view>
    </HomeLayout>
</template>

<script setup>
import HomeLayout from '@/components/layouts/HomeLayout.vue';
</script>